// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2xlOi","title":"ClientCherryInfo_title__2oPFQ","itemText":"ClientCherryInfo_itemText__2qsOa"};